export default {
  options: {
    type: [Array, Object, Function],
    default: () => ({})
  },
  // Set it to true when options is similar to : [{value, label}, {}, {}]
  useArrayOptions: {
    type: [Boolean, Number, String],
    default: false
  },
  blankOption: {
    type: [String, Number],
    default: null
  },
  blankOptionDisabled: {
    type: [String, Number, Boolean],
    default: true
  },
  endBlankOption: {
    type: [String, Number],
    default: null
  },
  endBlankOptionDisabled: {
    type: [String, Number, Boolean],
    default: true
  },
  reduceOptions: {
  },
  reduceLabel: {
  },
  reduceValue: {
  },
  filter: {
  },
  sortLabels: {
    type: [String, Number, Boolean, Function],
    default: false // true/asc/desc/ascstring/descstring/ascnumber/descnumber
  },
  sortValues: {
    type: [String, Number, Boolean, Function],
    default: false // true/asc/desc/ascstring/descstring/ascnumber/descnumber
  },
  sortBy: {
  },
  cloneOptions: {
  },
}
